export default "__VITE_ASSET__BQ8IqqkT__"